
(function () {
    class commentsCtrl {
        constructor($rootScope, $element, $scope, $sce, resource, $uibModal, $filter, validator, $http) {
            if (!$rootScope.commentsCtrl) $rootScope.commentsCtrl = {};
            $scope.vm = $rootScope.commentsCtrl;
            this.scope = $scope;
            this.sce = $sce;
            this.rest = resource;
            this.http = $http;
            this.modal = $uibModal;
            this.trans = $filter('trans');
            this.data = {};
            this.element = $element;
            $scope.$watch('vm.entityId', this.getComments.bind(this));
            this.validator = validator;
            this.ckeditor = {
                height: 300,
                toolbarGroups: [
                    {
                        name: 'editing',
                        // groups: ['find', 'selection', 'spellchecker']
                    },
                    {name: 'font'},
                    {name: 'styles'},
                    {name: 'colors'}
                ]
            };
        }

        /**
         * store new comment
         * @param $index
         */
        post($index) {
            this.isLoading = true;
            const entityType = this.scope.vm.entityType;
            const entityId = this.scope.vm.entityId;

            if(this.data.comment_id) {
                // Update existing comment - PUT /comments/{model}/{id}/{comment_id}
                this.rest.init('comments/' + entityType + '/' + entityId).update({
                    data: {
                        'comment': this.data.items[$index].comment
                    },
                    id: this.data.comment_id
                }).then(() => {
                    this.data.comment_id = null;
                    this.getComments();
                });
            } else {
                // Create new comment - POST /comments/{model}/{id}
                this.rest.init('comments/' + entityType + '/' + entityId).create({
                    data: {
                        'comment': this.data.comment
                    }
                }).then(() => {
                    this.data.comment = '';
                    this.getComments();
                });
            }
            $('#addComment').show();
        }

        /**
         * load comments
         */
        getComments() {
            this.isLoading = true;
            if (!this.scope.vm.entityId) return;

            const entityType = this.scope.vm.entityType;
            const entityId = this.scope.vm.entityId;

            // GET /comments/{model}/{id} - using $http directly for array response
            this.http.get('/comments/' + entityType + '/' + entityId)
                .then(response => {
                    this.scope.vm.comments = response.data;
                    this.data.items = response.data;
                    this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        }


        /**
         * delete comment
         * @param $index
         */
        deleteComment($index) {
            let ctrl = this;
            var modalInstance = this.modal.open({
                animation: true,
                component: 'modalConfirm',
                resolve: {
                    content: () => {
                        return ctrl.trans("ARE_YOU_SURE_DELETE");
                    },
                    title: () => {
                        return ctrl.trans("DELETE");
                    }
                }
            });

            modalInstance.result.then((response) => {
                if (response === 'cancel') return;

                const entityType = this.scope.vm.entityType;
                const entityId = this.scope.vm.entityId;
                const commentId = this.data.items[$index].comment_id;

                // DELETE /comments/{model}/{id}/{comment_id}
                this.rest.init('comments/' + entityType + '/' + entityId).delete({
                    id: commentId,
                    success: () => {
                        this.data.items.splice($index, 1);
                    }
                });
            });
        }

        br2nl(str) {
            return str.replace(/<br\s*\/?>/mg, "\r");
        }

        editComment(item, index) {
            $('#addComment').hide();
            this.data.comment_id = item.comment_id;
            this.data.items[index].edit = true;
        }

        validateSomeInputs() {
            this.custom_errors = null;
            this.has_error = false;

            if(!this.data.comment){
                $('[ng-model="commentsCtrl.data.comment"]').css("border", "1px solid red");
                if (!this.custom_errors) this.custom_errors = [];
                this.custom_errors.push(this.trans('LANG.COMMENT_REQUIRED'));
                this.has_error = true;
            } else {
                $('[ng-model="commentsCtrl.data.comment"] .select2-selection--single').css("border", "1px solid #c2cad8");
            }

            if(this.has_error){
                $('.custom_error_messages').css('display', 'block');
            } else {
                $('.custom_error_messages').css('display', 'none');
                this.post();
            }

            this.data.addComment = false;
        }
    }

    angular.module('kv').controller('commentsCtrl', commentsCtrl);
}());